import { validateProcedure } from './procedureValidator';
import { failedOutcome, resolveFood } from './outcome';
import type { FoodInput, FoodTestOutcome, ProcedureState } from './types';

export function getEmulsionOutcome(food: FoodInput, procedure: ProcedureState): FoodTestOutcome {
  const validation = validateProcedure('lipid', procedure);
  if (!validation.valid) return failedOutcome('lipid', validation.errors.join(' '));
  const sample = resolveFood(food);
  const level = sample.composition.lipid;
  const positive = level >= 0.15;
  return {
    test: 'lipid',
    category: !positive ? 'negative' : level >= 0.65 ? 'strong-positive' : 'positive',
    observation: positive ? 'A cloudy, milky-white emulsion forms after the ethanolic extract is added to water.' : 'The mixture remains clear; lipid is not detected.',
    colour: positive ? '#f5f4ec' : '#d9eef5',
    colourName: positive ? 'milky white' : 'clear',
    precipitate: false,
    emulsion: positive,
    reasoning: 'Ethanol dissolves lipid; when water is added afterwards, dispersed lipid droplets scatter light and make a cloudy emulsion.',
    warnings: validation.warnings,
  };
}